import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const LRStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnLevkategori,
  rutinInfos.rtnAttestGrupp,
  rutinInfos.rtnAttestOmrade,
  rutinInfos.rtnUtbetalningsvag,
  rutinInfos.rtnValuta,
  rutinInfos.rtnBank,
  rutinInfos.rtnFakturamottagningsvag,
  rutinInfos.rtnFakturakoder,
  rutinInfos.rtnFakturaradskoder,
  rutinInfos.rtnAttestforslag,
  rutinInfos.rtnClearingArtiklar,
];

export default LRStyrvardeMeny;
